import { $ } from '../vendors/jquery';

const anchorAnimate = {
    init() {
        function scrollToAnchor(hash) {
            const $target = $(hash);
            if (!$target.length) return;

            const productsNav = $('.product-nav-wrapper');
            const headerHeight = $('header').outerHeight();
            let productsNavHeight = 0;

            if( typeof productsNav !== 'undefined' && productsNav.length > 0 ) {
                productsNavHeight = productsNav.outerHeight();
            }

            $('html, body').stop().animate({
                scrollTop: $target.offset().top - headerHeight - productsNavHeight
            }, 600);
        }
        
        $(document).on('click', 'a[href*="#"]', function (e) {
            const hash      = this.hash;

            if (!hash) return;

            const winLocation = window.location;
            const linkUrl   = this.pathname.replace(/^\//, '');
            const pageUrl   = winLocation.pathname.replace(/^\//, '');

            // Same page → animate only
            if (linkUrl === pageUrl && this.hostname === winLocation.hostname) {
                e.preventDefault();
                scrollToAnchor(hash);
            }
            // Different page → allow navigation (animation handled on load)
        });

        $(window).on('load', function () {
            if (window.location.hash) {
                scrollToAnchor(window.location.hash);
            }
        });
    }
};

export default anchorAnimate;
